export const FLUTTERWAVE_TEST_PUBLIC_KEY = `FLWPUBK_TEST-1971e8a010c15083bc0a0f7c388fc1f1-X`;
export const FLUTTERWAVE_TEST_SECRET__KEY = `FLWSECK_TEST-18f406d0f1d379dad92b9294742c976c-X`;
export const FLUTTERWAVE_TEST_ENCRYPTION_KEY = 'FLWSECK_TEST0a9b68785aed';
export const FLUTTERWAVE_OLD_PUBLIC_KEY = `FLWPUBK-efa19c33b051d40ced376c7bd9a75a29-X`;
export const FLUTTERWAVE_PUBLIC_KEY = `FLWPUBK-92e617bad9f8dfdf3cf5a06dad97b2f7-X`;

export const THE_TELLER_API_KEY = `YzQ5MDc1YzY2YjFkNDU5YWQzZWUxYzNhNmJiODc5Y2Y=`;
export const PAYSTACK_VERIFICATION_URL = `https://api.paystack.co/transaction/verify/`;
export const PAYSTACK_CHARGE_AUTH_URL = `https://api.paystack.co/transaction/charge_authorization`;
export const PAYSTACK_PK_GH_TEST_KEY = `pk_test_e3ec372c59321b0d29de291f7c32ab97494d9649`;
export const PAYSTACK_PK_GH_LIVE_KEY = `pk_live_f084164d9488b05581291a92226897e704c0abca`;

// flutterwave plans
export const FLUTTERWAVE_150_PLAN_1_MONTH = '7402';
export const FLUTTERWAVE_150_PLAN_3_MONTHS = '16606';
export const FLUTTERWAVE_150_PLAN_6_MONTHS = '7403';
export const FLUTTERWAVE_150_PLAN_1_YEAR = '7401';

export const FLUTTERWAVE_200_PLAN_1_MONTH = '7405';
export const FLUTTERWAVE_200_PLAN_3_MONTHS = '16617';
export const FLUTTERWAVE_200_PLAN_6_MONTHS = '16655';
export const FLUTTERWAVE_200_PLAN_1_YEAR = '16656';

export const FLUTTERWAVE_250_PLAN_1_MONTH = '7406';
export const FLUTTERWAVE_250_PLAN_3_MONTHS = '16618';
export const FLUTTERWAVE_250_PLAN_6_MONTHS = '16653';
export const FLUTTERWAVE_250_PLAN_1_YEAR = '16654';

// paystack plans
export const PAYSTACK_150_PLAN_1_MONTH = 'PLN_xo1hd2k2b97rhhu';
export const PAYSTACK_150_PLAN_3_MONTHS = 'PLN_mwb4pkqamh8ofvi';
export const PAYSTACK_150_PLAN_6_MONTHS = 'PLN_czzaqwbobkulgs7';
export const PAYSTACK_150_PLAN_1_YEAR = 'PLN_rhkoue0t5bai72n';

export const PAYSTACK_200_PLAN_1_MONTH = 'PLN_h40o5tb8j0izdzg';
export const PAYSTACK_200_PLAN_3_MONTHS = 'PLN_i1538qlv3xkka7r';
export const PAYSTACK_200_PLAN_6_MONTHS = 'PLN_kul7eb0fhkty9m2';
export const PAYSTACK_200_PLAN_1_YEAR = 'PLN_gkfkip1cihbpkcv';

export const PAYSTACK_250_PLAN_1_MONTH = 'PLN_4vaoxlc3xxo477g';
export const PAYSTACK_250_PLAN_3_MONTHS = 'PLN_bo4ry76x2oymxql';
export const PAYSTACK_250_PLAN_6_MONTHS = 'PLN_4vaoxlc3xxo477g';
export const PAYSTACK_250_PLAN_1_YEAR = 'PLN_yvtjyjvgfhs4neh';
